{
  "common": {
    "generic_error": "A system error occurred, please wait a few minutes and try again.",
    "terms": {
      "agree_prefix": "I agree to the",
      "terms_of_service": "terms of service"
    }
  },
  "company_website_input": {
    "label": "Your Website"
  },
  "register_form": {
    "email_label": "Your Business Email Address",
    "name_label": "Your Full Name",
    "company_name_label": "Your Company Name",
    "password_label": "Password",
    "role": {
      "default_label": "I'd like to trial SparkLayer on...",
      "team_member_label": "I'm activating my account on behalf of:",
      "placeholder": "Please select here",
      "merchant_default": "On my own brand's online store",
      "partner_default": "As an agency on a client's online store",
      "merchant_team_member": "A merchant who is using SparkLayer",
      "partner_team_member": "An agency who is using SparkLayer for a client"
    },
    "partner_terms_of_service": "partner terms of service",
    "submit": "Continue →"
  },
  "enterprise_register_form": {
    "email_label": "Your Business Email Address",
    "name_label": "Your Full Name",
    "company_name_label": "Your Company Name",
    "company_website_placeholder": "e.g. www.yourcompany.com",
    "password_label": "Password",
    "submit": "Continue →"
  },
  "invite_register_form": {
    "email_label": "Email Address",
    "name_label": "Full Name",
    "password_label": "Password",
    "agree_prefix": "I agree to",
    "terms_of_service": "terms of service",
    "submit": "Create Account",
    "success": "Please, click the accept invitation link in the email."
  }
}
